import React, { ComponentType, FC } from "react";

import { ISelectProps } from "../components";
import { IUseFetchOptionsParams, useFetchOptions } from "./useFetchOptions";

export interface ICodelistFactoryImplementationProps<Option>
  extends Pick<ISelectProps<Option>, "isLoading" | "options"> {}

export type ICodelistFactoryProps<Props, Option = any, SearchParams = any> = Omit<
  Pick<IUseFetchOptionsParams<Option, SearchParams>, "isDisabled" | "filterAfterFetch" | "searchParams"> & Props,
  keyof ICodelistFactoryImplementationProps<Option>
>;

export const codelistFactory = <
  Props extends ICodelistFactoryImplementationProps<Option>,
  Option = any,
  SearchParams = any,
>(
  fetchData: IUseFetchOptionsParams<Option, SearchParams>["fetchData"],
  Component: ComponentType<Props>,
): ComponentType<ICodelistFactoryProps<Props, Option, SearchParams>> => {
  const Codelist: FC<ICodelistFactoryProps<Props, Option, SearchParams>> = props => {
    const { filterAfterFetch, searchParams, ...rest } = props;
    const { isLoading, options } = useFetchOptions({
      isDisabled: rest.isDisabled,
      fetchData,
      filterAfterFetch,
      searchParams,
    });

    return <Component {...(rest as Props)} isLoading={isLoading} options={options} />;
  };

  return Codelist;
};
